import { CommonState, commonReducer, selectAuthData, selectIsLoading, selectDialog, selectLanguage, selectRole, selectCurrency, selectDisplayLoginDialog, selectBlockDocument, selectCurrentPageTitle } from "./shared/state/state.index";
import { createSelector } from "@ngrx/store";

const reducers = {
    common: commonReducer,
};

interface AppState {
    common: CommonState
}

export { reducers, AppState };

export const selectCommon = (state) => state.common;
export const selectAuthDataCommonState = createSelector(selectCommon, selectAuthData)
export const selectRoleInCommonState = createSelector(selectCommon, selectRole)


export const selectLanguageInCommonState = createSelector(selectCommon, selectLanguage)
export const selectCurrencyInCommonState = createSelector(selectCommon, selectCurrency)
export const selectLoadingCommonState = createSelector(selectCommon, selectIsLoading)
export const selectDialogCommonState = createSelector(selectCommon, selectDialog)
export const selectDisplayLoginDialogInCommonState = createSelector(selectCommon, selectDisplayLoginDialog)
export const selectBlockDocumentInCommonState = createSelector(selectCommon, selectBlockDocument)
export const selectCurrentPageTitleInCommonState = createSelector(selectCommon, selectCurrentPageTitle)

